import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "map-controls" }
const _hoisted_2 = { class: "buttons" }
const _hoisted_3 = {
  key: 0,
  class: "map-type-control"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-layers" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "map-label-control"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "icon-pin" }, null, -1)
const _hoisted_7 = {
  key: 2,
  class: "map-streetview-control"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "icon-streetview" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { id: "pano" }, null, -1)
const _hoisted_10 = {
  key: 3,
  class: "map-navigation-control"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "icon-nav" }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "map-zoom-control"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.mapTypeControlEnabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_multiselect, {
              modelValue: _ctx.mapType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mapType) = $event)),
              "track-by": "key",
              label: "title",
              "show-labels": false,
              "open-direction": "top",
              options: _ctx.mapTypeIds,
              searchable: false,
              "close-on-select": true,
              multiple: false,
              "allow-empty": false,
              onSelect: _ctx.onMapTypeChange
            }, {
              singleLabel: _withCtx(({ option }) => [
                _hoisted_4,
                _createElementVNode("span", null, _toDisplayString(option.title), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "options", "onSelect"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.labelsEnabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "button button-map-label",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onShowLabels && _ctx.onShowLabels(...args)))
            }, [
              _hoisted_6,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('MapControls.labels')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.streetViewControlEnabled && _ctx.position && _ctx.mapContainer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("button", {
              type: "button",
              class: "button button-streetview",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onStreetView && _ctx.onStreetView(...args)))
            }, [
              _hoisted_8,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('MapControls.streetview')), 1)
            ]),
            _hoisted_9
          ]))
        : _createCommentVNode("", true),
      (_ctx.navigationControlEnabled && _ctx.position)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("a", {
              href: _ctx.navigationUrl,
              target: "_blank",
              class: "button button-navigation"
            }, [
              _hoisted_12,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('MapControls.navigation')), 1)
            ], 8, _hoisted_11)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.zoomControlEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("button", {
            type: "button",
            class: "button button-zoom-current",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onZoomCurrentLocation && _ctx.onZoomCurrentLocation(...args)))
          }),
          _createElementVNode("button", {
            type: "button",
            class: "button button-zoom-in",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onZoomIn && _ctx.onZoomIn(...args)))
          }),
          _createElementVNode("button", {
            type: "button",
            class: "button button-zoom-out",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onZoomOut && _ctx.onZoomOut(...args)))
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}